import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useScenarioCreateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import { ScenarioForm, ScenarioFormData } from "src/forms/ScenarioForm";

interface Props {
  onClose: () => void;
}

export function ScenarioCreatePage(props: Props) {
  const { t } = useTranslation();
  const { caseId = ""} = useParams<{ caseId: string }>();
  const navigate = useNavigate();
  const { data: acase } = useCase(caseId);
  const createMutation = useScenarioCreateMutation(caseId);

  /**
   * Functions
   */
  async function handleSave(values: ScenarioFormData) {
    const result = await createMutation.mutateAsync(values);
    navigate(`/cases/${caseId}/scenarios/${result.id}`);
  }

  return render();

  function render() {
    if (!acase) return null;

    return (
      <>
        <ScenarioForm
          title={t("label.addScenario")}
          data={{ name: "" }}
          onClose={() => props.onClose}
          onSubmit={handleSave}
          isLoading={createMutation.isLoading}
        />
      </>
    );
  }
}
